onComplete(function () {
	// Add code here.
	const headers = document.querySelectorAll('h1, h2, h3, h4, h5, h6,.h1,.h2');

	headers.forEach(header => {
		const text = header.textContent.trim();
		if (!text) return;

		const words = text.split(/\s+/);
		const firstWord = words.shift();

		header.innerHTML = `<span class="stroke-word">${firstWord}</span> ${words.join(' ')}`;
	});

	document.querySelectorAll('.dropdown-menu').forEach(menu => {
		menu.addEventListener('click', e => {
			e.stopPropagation();
		});
	});



	const updateHeight = () => {
		const nav = document.querySelector('.nav-header');
		const menu = document.querySelector('.dropdown-menu.show');

		const navH = nav ? nav.clientHeight : 0;
		const menuH = menu ? menu.clientHeight : 0;

		const total = Math.floor(navH + menuH);

		document.documentElement.style.setProperty('--total-nav-height', `${total}px`);
	};

	window.addEventListener('load', updateHeight);

	const resizer = new ResizeObserver(updateHeight);
	if (document.querySelector('.nav-header')) {
		resizer.observe(document.querySelector('.nav-header'));
	}

	const observer = new MutationObserver((mutations) => {
		updateHeight();
	});

	const navContainer = document.querySelector('.nav-header');
	if (navContainer) {
		observer.observe(navContainer, {
			attributes: true,
			subtree: true,
			attributeFilter: ['class']
		});
	}

	document.querySelectorAll(".growth-preview-button, .growth-preview .image").forEach(button => {
		button.addEventListener("click", function (event) {
			let parentDiv = this.closest(".growth-preview");
			if (parentDiv) {
				event.stopImmediatePropagation();
				parentDiv.classList.toggle("active");
				if (window.innerWidth <= 991) {
					if (parentDiv.classList.contains("active")) {
						let blogContent = parentDiv.closest("#growth-item-preview");
						if (blogContent) {
							blogContent.scrollIntoView({ behavior: "smooth" });
						}
					}
				}
			}
		});
	});
});